import React from 'react';

const BootstrapIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0 0 512 408"
        >
            <defs>
                <linearGradient
                    id="bs-logo-a"
                    x1="76.079"
                    x2="523.48"
                    y1="10.798"
                    y2="365.945"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9013fe"></stop>
                    <stop offset="1" stopColor="#6610f2"></stop>
                </linearGradient>
                <linearGradient
                    id="bs-logo-b"
                    x1="193.508"
                    x2="293.514"
                    y1="109.74"
                    y2="278.872"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset="1" stopColor="#f1e5fc"></stop>
                </linearGradient>
                <filter
                    xmlns="http://www.w3.org/2000/svg"
                    id="bs-logo-c"
                    width="197"
                    height="249"
                    x="161.901"
                    y="83.457"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    ></feColorMatrix>
                    <feOffset dy="4"></feOffset>
                    <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
                    <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    ></feBlend>
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    ></feBlend>
                </filter>
            </defs>
            <path
                fill="url(#bs-logo-a)"
                d="M56.481 53.32C55.515 25.58 77.128 0 106.342 0h299.353c29.214 0 50.827 25.58 49.861 53.32-.928 26.647.277 61.165 8.964 89.31 8.715 28.232 23.411 46.077 47.48 48.37v26c-24.069 2.293-38.765 20.138-47.48 48.37-8.687 28.145-9.892 62.663-8.964 89.311.966 27.739-20.647 53.319-49.861 53.319H106.342c-29.214 0-50.827-25.58-49.86-53.319.927-26.648-.278-61.166-8.966-89.311C38.802 237.138 24.07 219.293 0 217v-26c24.069-2.293 38.802-20.138 47.516-48.37 8.688-28.145 9.893-62.663 8.965-89.31z"
            ></path>
            <path
                fill="url(#bs-logo-b)"
                stroke="#fff"
                d="M267.103 312.457c47.297 0 75.798-23.158 75.798-61.355 0-28.873-20.336-49.776-50.532-53.085v-1.203c22.185-3.609 39.594-24.211 39.594-47.219 0-32.783-25.882-54.138-65.322-54.138h-88.74v217h89.202zm-54.692-189.48h45.911c24.958 0 39.131 11.128 39.131 31.279 0 21.505-16.484 33.535-46.372 33.535h-38.67v-64.814zm0 161.961v-71.431h45.602c32.661 0 49.608 12.03 49.608 35.49 0 23.459-16.484 35.941-47.605 35.941h-47.605z"
                filter="url(#bs-logo-c)"
            ></path>
        </svg>
        // <svg
        //     xmlns="http://www.w3.org/2000/svg"
        //     width="70"
        //     height="70"
        //     viewBox="0 0 512 407.864"
        // >
        //     <path
        //         fill="#7952b3"
        //         fillRule="evenodd"
        //         d="M106.344 0C77.13 0 55.513 25.57 56.481 53.3c.929 26.641-.278 61.145-8.964 89.283C38.8 170.8 24.068 188.681 0 190.976v25.912c24.068 2.3 38.8 20.172 47.516 48.393 8.687 28.138 9.893 62.642 8.964 89.283-.968 27.726 20.649 53.3 49.868 53.3h299.347c29.214 0 50.827-25.57 49.859-53.3-.929-26.641.278-61.145 8.964-89.283 8.717-28.221 23.413-46.1 47.482-48.393v-25.912c-24.068-2.3-38.764-20.172-47.482-48.393-8.687-28.134-9.893-62.642-8.964-89.283.968-27.726-20.645-53.3-49.859-53.3H106.34zm240.775 251.067c0 38.183-28.481 61.34-75.746 61.34h-80.458a8.678 8.678 0 01-8.678-8.678V104.136a8.678 8.678 0 018.678-8.678h80c39.411 0 65.276 21.348 65.276 54.124 0 23.005-17.4 43.6-39.567 47.208v1.2c30.176 3.31 50.495 24.21 50.495 53.077zm-84.519-128.1h-45.876v64.8h38.639c29.87 0 46.34-12.028 46.34-33.527-.003-20.148-14.163-31.273-39.103-31.273zm-45.876 90.511v71.411h47.564c31.1 0 47.573-12.479 47.573-35.931s-16.935-35.484-49.573-35.484h-45.564z"
        //     ></path>
        // </svg>
    );
};

export default BootstrapIcon;